import fs from 'node:fs'
import path from 'node:path'
import { CONFIG_FILE_NAME } from '@core-engine/config/resolver.js'
import type { BetterstartConfig } from '@core-engine/config/types.js'
import { getCurrentCliVersion } from '@core-engine/snapshots/store.js'

function quote(value: string): string {
  return `'${value.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`
}

function formatArray(values: string[]): string {
  if (values.length === 0) {
    return '[]'
  }

  return `[${values.map((value) => quote(value)).join(', ')}]`
}

export function serializeConfig(config: BetterstartConfig): string {
  const nextConfig = config.frameworkConfig.next

  return `import { defineConfig } from 'betterstart-cli'

export default defineConfig({
  framework: 'next',
  cliVersion: ${quote(getCurrentCliVersion())},

  frameworkConfig: {
    next: {
      namespace: ${quote(nextConfig.namespace)},
      srcDir: ${String(nextConfig.srcDir)},
      version: ${String(nextConfig.version)},
      paths: {
        admin: ${quote(nextConfig.paths.admin)},
        schemas: ${quote(nextConfig.paths.schemas)},
        pages: ${quote(nextConfig.paths.pages)},
        login: ${quote(nextConfig.paths.login)},
        api: ${quote(nextConfig.paths.api)},
      },
    },
  },

  database: {
    provider: ${quote(config.database.provider)},
    migrationsDir: ${quote(config.database.migrationsDir)},
  },

  presets: {
    installed: ${formatArray(config.presets.installed)},
  },

  integrations: {
    installed: ${formatArray(config.integrations.installed)},
  },

  email: {
    provider: ${quote(config.email.provider)},
  },

  storage: {
    provider: ${quote(config.storage.provider)},
  },

  linter: ${quote(config.linter)},

  generated: {
    entities: ${formatArray(config.generated.entities)},
    singles: ${formatArray(config.generated.singles)},
    forms: ${formatArray(config.generated.forms)},
  },
})
`
}

export function writeConfigFile(cwd: string, config: BetterstartConfig): void {
  fs.writeFileSync(path.join(cwd, CONFIG_FILE_NAME), serializeConfig(config), 'utf-8')
}
